// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Autoplay, Pagination} from 'swiper/modules';
// import Swiper and modules styles

document.addEventListener('DOMContentLoaded', function () {
    generateProductGridSwiper();
});

function generateProductGridSwiper() {
    const productSwiperDOM = document.querySelector('.westcam-product-slider');    
    const productSwiper = new Swiper(productSwiperDOM, {
        modules: [Autoplay, Pagination],
        slidesPerView: 1,
        spaceBetween: 20,
        autoHeight: true,
        speed: 1000,
        loop: true,
        pagination: {
            el: '.swiper-pagination-mobile',
            clickable: true,
        },
    });
    productSwiper.on('slideChange', function () {
        //remove active class from all pagination items
        const paginationItems = document.querySelectorAll('.swiper-navigation-item');
        for (let i = 0; i < paginationItems.length; i++) {
            paginationItems[i].classList.remove('active');
        }
        //add active class to the current pagination item
        paginationItems[productSwiper.realIndex].classList.add('active');
    });

    //listen for clicks on all swiper-pagination-items and change the active slide to data-slide attribute
    const paginationItems = document.querySelectorAll('.swiper-navigation-item');
    for (let i = 0; i < paginationItems.length; i++) {
        paginationItems[i].addEventListener('click', function () {
            productSwiper.slideTo(this.dataset.slide);
            //add class active to the clicked pagination item
            for (let i = 0; i < paginationItems.length; i++) {
                paginationItems[i].classList.remove('active');
            }
            this.classList.add('active');
        });
    }





    //GRID ANIMATIOn
    const productSwiperGrid = document.getElementById('product-slider-grid');
    //get all of its paths
    const productSwiperGridPaths = productSwiperGrid.getElementsByTagName('path');
    //for each path, animate the stroke-dashoffset from 100% to 0% over 1.5 seconds
    for (let i = 0; i < productSwiperGridPaths.length; i++) {
        //get path total length
        const currentPath = productSwiperGridPaths[i];
        const pathLength = currentPath.getTotalLength();
        currentPath.style.strokeDashoffset = pathLength;
        currentPath.style.strokeDasharray = pathLength;
        productSwiperGridPaths[i].animate(
            [
                { strokeDasharray: pathLength, strokeDashoffset: pathLength },
                { strokeDasharray: pathLength, strokeDashoffset: 16000 }
            ],
            {
                duration: 60000,
                easing: "linear",
                fill: "forwards",
            }
        );
    }
}